<template>
  <div class="h5-currency-content">
    <div class="currency-content-title">
      Currency
    </div>
    <img
      src="@/assets/H5/home/left.svg"
      alt=""
      class="currency-left"
      @click="handleClose"
    >
    <div class="h5-currency-basic">
      <div
        v-for="item in currency.list"
        :key="item.targetCurrency"
        class="currency-item"
        @click="currency.update(item)"
      >
        <div class="currency-item-left">
          <div class="currency-item-left-title">
            {{ item.targetCurrency.slice(0, 2) }} ({{ item.targetUnit }})
          </div>
        </div>
        <div
          v-if="currency.current.targetCurrency === item.targetCurrency"
          class="selected"
        >
          <img
            src="@/assets/H5/filters/check.svg"
            alt=""
          >
        </div>
        <div
          v-else
          class="unselected"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCurrencyStore } from '@/pinia/currency'

const props = defineProps({
  handleClose: Function
})
const handleClose = props.handleClose

const currency = useCurrencyStore()
</script>

<style lang="less" scoped>
@import './index.less';
</style>
